export enum NoGoType {
    Generic = 0,
    EndOfShift = 1,
    StartOfShift = 2,
}
